type AnyFunction = (...args: readonly any[]) => unknown;

const cacheStore = new WeakMap<AnyFunction, Map<string, any>>();

export const memoize = <FunctionToMemoize extends AnyFunction>(
  originalFn: FunctionToMemoize,
  cacheKey?: (args: Parameters<FunctionToMemoize>) => any
): FunctionToMemoize & { clear: () => void } => {
  const cache = new Map<string, any>();

  const memoized = function (
    this: any,
    ...args: Parameters<FunctionToMemoize>
  ): ReturnType<FunctionToMemoize> {
    const key = cacheKey ? cacheKey(args) : args[0];
    const cached = cache.get(key);

    if (cached) {
      return cached;
    }

    const result = originalFn.apply(
      this,
      args
    ) as ReturnType<FunctionToMemoize>;

    cache.set(key, result);

    return result;
  } as FunctionToMemoize;

  cacheStore.set(memoized, cache);

  return Object.assign(memoized, {
    clear: () => cache.clear(),
  });
};
